<template>
    <div class="row-no-full" style="margin: 10px 0;">

      <div v-for="(v,i) in formList_" :key='i' class="item">

        <template v-if="v.type=='input'" >

          <div>
            <el-input size='small' :placeholder='v.title' v-model="v.value"></el-input>
          </div>

        </template>


        <template v-if="v.type=='select'">

          <div>
            <el-select size='small' :placeholder="v.title" v-model="v.value" :clearable='true'>

              <el-option v-for="(vv,ii) in v.list" :key='ii' :label="vv.label" :value="vv.key"></el-option>

            </el-select>
          </div>

        </template>



      </div>

      <div >

        <slot v-bind:form='formList_'></slot>
      </div>


      <div>
        <el-button type='primary' @click='submit' size='small'>搜索</el-button>
      </div>



    </div>
</template>

<script>
    export default {
        name: "Search",
        data() {
            return {

              formList_:this.formList

            }
        },
        methods: {


          submit(){



            this.$emit('search',this.formList_);

          },
          updateList(index, data) {


            // this.formList_[index].list=data;

            let item = this.cloneObj(this.formList_[index])

            item.list = data;

            this.formList_.splice(index, 1, item)


          }


        },
        created() {

          // console.log(this.$route.query);

          let search=this.$route.query.search;

          if(search){

            search=JSON.parse(search);

            this.formList_=search;

          }


        },
        computed: {

        },
        props: {

          formList:{

            type:Array,
            default:function(){


              return [
                // {type:'input',title:'商品名称',value:'',field:'name',condition:'like'},
                // {type:'select'}
              ];
            }

          }


        },
        watch:{

          formList(value){

            this.formList_=value;

          }

        }

    }
</script>

<style scoped>

  .item>div{

    width: 200px;
    margin-right: 10px;

  }

</style>



// WEBPACK FOOTER //
// src/components/common/Search.vue